import { render, staticRenderFns } from "./ProvidersForm.vue?vue&type=template&id=4ef0e376&scoped=true&"
import script from "./ProvidersForm.vue?vue&type=script&lang=js&"
export * from "./ProvidersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0e376",
  null
  
)

export default component.exports